import { render, staticRenderFns } from "./onlinePractice.vue?vue&type=template&id=6cf41198&scoped=true"
import script from "./onlinePractice.vue?vue&type=script&lang=js"
export * from "./onlinePractice.vue?vue&type=script&lang=js"
import style0 from "./onlinePractice.vue?vue&type=style&index=0&id=6cf41198&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf41198",
  null
  
)

export default component.exports